<div class="page-section" id="ai-tooling">
  <div class="section-content">
    <div class="left">
      <h2>Utilize AI to Streamline Your Submission</h2>

      <p>
        Our tooling utilizes an advanced in-house AI model to automate the
        submission process. Just take a photo of the front and back of your card
        and let our AI do the legwork.
      </p>

      <a class="primary-rounded-btn" [href]="customerAppURLBase + '/register'"
        >Try It For Yourself</a
      >

      <img id="large-graphic" src="assets/images/extraction-graphic.png" />
      <img
        id="small-graphic"
        src="assets/images/baseball-extraction-graphic.png" />
    </div>

    <div class="right">
      <img src="assets/images/device-preview.png" />
    </div>
  </div>
</div>
